export class BDMatrix {
  public bDMatrixId: number;
  public studySearchStrategyId: number;
  public comparableId: number;
  public comparableStatusId?: number;
  public bDMatrixSubsetId?: number;
  public rejectedReason: string;
  public preliminaryStatusId?: number;
  public preliminaryRejectedReason: string;
  public companyName: string;
  public companyShortName: string;
  public companyWebSite: string;
  public countryName: string;
  public bvDId: string;
  public tradeDescNL: string;
  public tradeDescNLLang: string;
  public tradeDescEN: string;
  public fullOverviewEN: string;
  public comment: string;
  public referenceId: number;

  createdBy: number;
  createdOn: Date;
  updatedBy: number;
  updatedOn: Date;
  isReviewed?: boolean;
}
